import { render, staticRenderFns } from "./SnapshotImages.vue?vue&type=template&id=db16139c&scoped=true&"
import script from "./SnapshotImages.vue?vue&type=script&lang=ts&"
export * from "./SnapshotImages.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotImages.vue?vue&type=style&index=0&id=db16139c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db16139c",
  null
  
)

export default component.exports